export const selectFactoryCities = (state) => state.factoryCities.factoryCities.cities;

export const selectFactoryCitiesLoading = (state) => state.factoryCities.factoryCities.loading;
export const selectFactoryCitiesError = (state) => state.factoryCities.factoryCities.error;


export const selectFactoryTerminationCities = (state) => state.factoryCities.terminationCities.cities;

export const selectFactoryTerminationCitiesLoading = (state) => state.factoryCities.terminationCities.loading;
export const selectFactoryTerminationCitiesError = (state) => state.factoryCities.terminationCities.error;